import Dexie from "dexie";

export const db = new Dexie("SRG Invoice Book");
db.version(1).stores({
  invoices: "++id", // Primary key and indexed props
});

